// ============================================================================
// AdminBookingsPanel — top-level Room bookings section.
// ============================================================================
// Wraps AgcCalendar — the existing shared-room calendar component. AgcCalendar
// already handles role-based access (UIF sees + edits everything; AGC sees
// + edits their own bookings; cross-org bookings are read-only). No prop
// changes needed here; we just give the calendar a page header and frame.
// ============================================================================

import { AgcCalendar } from './AgcCalendar';

export function AdminBookingsPanel() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Room bookings</h1>
        <p className="text-sm text-gray-600 mt-0.5">
          Shared room calendar across UIF events and AGC bookings. Click any
          time slot to create a new booking. Cross-org bookings show as
          read-only.
        </p>
      </div>

      <AgcCalendar />
    </div>
  );
}
